import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';
import { CheckboxInput, Button } from '@/v2/shared/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthFormRememberForget',
  props: {
  remember_me: {
    type: Boolean,
    default: false
  },
  forgot_password: {
    type: Boolean,
    default: false
  },
  forgotPasswordForm: {
    type: Boolean,
    default: false
  },
},
  emits: {
  'update:checked': (value: boolean) => typeof value === 'boolean',
  'forgotPasswordForm': (value: boolean) => typeof value === 'boolean'
},
  setup(__props, { emit: __emit }) {

const props = __props;

const checked = ref();

const emit = __emit;

const handleForgotPassword = () => {
  emit('forgotPasswordForm', true);
};

const handleGoBack = () => {
  emit('forgotPasswordForm', false);
};

const emitChecked = () => {
  if(props.remember_me){
    emit('update:checked', checked.value);
  }
};

watch(()=>checked.value, emitChecked);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['AuthFormRememberForget', { 'AuthRememberForgot_twoButtons': __props.remember_me && __props.forgot_password }])
  }, [
    (__props.remember_me && !__props.forgotPasswordForm)
      ? (_openBlock(), _createBlock(_unref(CheckboxInput), _mergeProps({
          key: 0,
          checked: checked.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
          label: 'Remember me',
          name: 'remember_me'
        }, _ctx.$attrs), null, 16, ["checked"]))
      : _createCommentVNode("", true),
    (!__props.forgotPasswordForm && __props.forgot_password)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 1,
          class: "forgotPassword",
          type: "link",
          onClick: handleForgotPassword
        }, {
          default: _withCtx(() => [
            _createTextVNode("Forgot password?")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.forgotPasswordForm)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 2,
          class: "forgotPassword goBack",
          type: "link",
          onClick: handleGoBack
        }, {
          default: _withCtx(() => [
            _createTextVNode("Go back")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})